import { render } from "./IconInfoSmall.vue?vue&type=template&id=1a07bb4c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconInfoSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a07bb4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a07bb4c', __exports__)) {
    api.reload('1a07bb4c', __exports__)
  }
  
  module.hot.accept("./IconInfoSmall.vue?vue&type=template&id=1a07bb4c", () => {
    api.rerender('1a07bb4c', render)
  })

}


export default __exports__